import React from 'react';
import LibraryNewsletterView from '../views/librarynewsletters/LibraryNewslettersView';
import CardContainer from './CardContainer';
import * as LibraryNewslettersSelector from '../../data/LibraryNewslettersSelector';

const LibraryNewslettersContainer = (props) => {
	const libraryNewslettersCardModel = LibraryNewslettersSelector.getLibraryNewsletters();
	return (
		<CardContainer 
			cardName="Library Newsletters" 
			cardModel={libraryNewslettersCardModel} 
			component={LibraryNewsletterView} 
			itemsToRender={5} 
			onItemClick={props.onItemClick}
			{...props}
		/>
	);
}

export default LibraryNewslettersContainer;



// WEBPACK FOOTER //
// ./src/react/containers/LibraryNewslettersContainer.jsx